import * as CryptoJS from 'crypto-js';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  private secretKey = 'MyStrongSecurityKey@123';   // move to env in prod

  encrypt(value: string): string {
    const encrypted = CryptoJS.AES.encrypt(value, this.secretKey).toString();
    return btoa(encrypted);   // make URL safe
  }

  decrypt(value: string): string {
    const decrypted = atob(value);
    return CryptoJS.AES.decrypt(decrypted, this.secretKey)
      .toString(CryptoJS.enc.Utf8);
  }
}
